<template>
    <div class="Background">
        <h2 class="Title">
            소셜 업로드
        </h2>

        <v-btn @click="testBtn">test버튼</v-btn>
        <v-btn @click="uploadBtn">업로드버튼</v-btn>
        <SocialUpload />
    </div>
</template>

<script>
import SocialUpload from '@/components/socialupload/SocialUpload.vue';
import SocialApi from '@/api/social/SocialApi';

export default {
    components: {
        SocialUpload,

    },
    methods: {
        async testBtn(){
            console.log("testBtn 버튼클릭");
            const response = await SocialApi.googleLogin();
            // sessionStorage.setItem("youtube_token", data.access_token);
        },
        async uploadBtn(){
            console.log("uploadBtn 버튼클릭");
            // const res = await axios.post('http://localhost:8008/api/youtube/upload');
            // const params = {

            // }
            const res = await SocialApi.uploadYouTube();
           
            console.log("uploadBtn => ", res);

            alert('uploaded successfully');
        },
    }
    
}
</script>